import { render } from "./GoalKRConfidenceActivity.vue?vue&type=template&id=71538b1b"
import script from "./GoalKRConfidenceActivity.vue?vue&type=script&lang=js"
export * from "./GoalKRConfidenceActivity.vue?vue&type=script&lang=js"
script.render = render

export default script